import { render, staticRenderFns } from "./fs-pill.vue?vue&type=template&id=0358fc04&scoped=true"
import script from "./fs-pill.vue?vue&type=script&lang=js"
export * from "./fs-pill.vue?vue&type=script&lang=js"
import style0 from "./fs-pill.vue?vue&type=style&index=0&id=0358fc04&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358fc04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0358fc04')) {
      api.createRecord('0358fc04', component.options)
    } else {
      api.reload('0358fc04', component.options)
    }
    module.hot.accept("./fs-pill.vue?vue&type=template&id=0358fc04&scoped=true", function () {
      api.rerender('0358fc04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/pills/fs-pill.vue"
export default component.exports